import React, { useEffect, useState } from 'react';
import { View, Text, StyleSheet, StatusBar, TouchableOpacity, ScrollView, Platform } from 'react-native';
import Btn from "../components/btn"
import INPU from "../components/input"
import Colors from '../constants/Colors';
import { Ionicons } from "@expo/vector-icons"
import { NativeBaseProvider, Radio, useMediaQuery } from 'native-base';
import { useDispatch, useSelector } from 'react-redux';
import { Addwhite, getcategory } from '../store/action/userProduct';
import AwesomeAlert from 'react-native-awesome-alerts';
import { logOut } from '../store/action/userLogin';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Image } from 'react-native';
import { FlatList } from 'react-native';










const Mdfwhite = (props) => {
    //const tokens = "2|WHyjzuT213icASOZyDMHFmRUaYcJfLA5S9Y9kjhh"
    const tokens = useSelector((store) => store.userLogin.datatoken);
    const dispatch = useDispatch();
    const [Wallet, setWallet] = useState(false)
    const [APP, setAPP] = useState([])



    const GetCategoryHandler = async () => {
        try {
            setWallet(true)
            const res = await dispatch(getcategory(tokens))




            setAPP(res.data.data.category)
            //   if (res.status=="success") {
            //     setWallet(true)

            //console.log( res.data.data.category);

            // }

            setWallet(false)
        } catch (err) {
            // logOutHandler()
        }
    };


    const logOutHandler = async () => {
        try {
            //   console.log("logout");
            await dispatch(logOut());
            await AsyncStorage.removeItem("access_token");
            props.navigation.navigate("splash");
        } catch (err) {
            console.log(err);
        }
    };


    useEffect(() => {
        GetCategoryHandler()
    }, [])




    const [isSmallScreen] = useMediaQuery({
        // minHeight: 280,
        // maxHeight: 480,
        maxWidth: 500
    });



    return (

        <NativeBaseProvider>



            <View style={{
                width: isSmallScreen ? "100%" : 500,
                height: "100%",
                marginLeft: isSmallScreen ? 0 : "35%",
                backgroundColor: Colors.background,
                position: Platform.OS == "web" ? "fixed" : "relative"
            }}>


                <View style={styles.viewHeader}>
                    <StatusBar backgroundColor={Colors.primary} />
                    <TouchableOpacity onPress={() => props.navigation.goBack()} style={styles.menu}   >
                        <Ionicons name="arrow-forward-outline" size={25} color={Colors.background} />
                    </TouchableOpacity>

                    <TouchableOpacity onPress={() => props.navigation.goBack()} style={styles.textheader}>
                        <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.background, padding: "5%" }}>
                            انتخاب نوع سفارش
                        </Text>
                    </TouchableOpacity>

                </View>

                <ScrollView style={{ backgroundColor: Colors.background1 }} >


                    <View style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", justifyContent: "space-between", width: "100%", marginTop: 10, padding: "5%" }}>
                        {APP.map((item, i) => {
                            return (



                                <TouchableOpacity onPress={() => {
                                    props.navigation.navigate("chat", {
                                        idcategory: item.id
                                    })
                                }}

                                    key={i} style={{ backgroundColor: Colors.secondText2, width: "45%", height: 250, marginTop: "5%", borderWidth: 2, borderColor: Colors.secondText, borderRadius: 10, flexDirection: "column", alignItems: "center" }} >
                                    <Image
                                        source={{
                                            uri: "https://npln.ir" + item.image
                                        }} alt={"image"}

                                        style={{ width: "100%", height: "70%", borderTopRightRadius: 10, borderTopLeftRadius: 10, }} />
                                    <View style={{ width: "100%", height: "30%", padding: 10, justifyContent: "center", alignItems: 'center' }}>
                                        <Text numberOfLines={2} style={{ fontFamily: "Montserrat", fontSize: 12, }}>{item.title}</Text>
                                    </View>


                                </TouchableOpacity>







                            )
                        })}




                    </View>

                </ScrollView>










                {/* 

            <AwesomeAlert
                    show={Wallet}
                    showProgress={false}
                    title="موفق"
                    message="تکه با موفقیت افزوده شد"
                    closeOnTouchOutside={false}
                    closeOnHardwareBackPress={false}
                    // showCancelButton={true}
                    showConfirmButton={true}
                    // cancelText="باشه"
                    confirmText="باشه"
                    confirmButtonColor={Colors.success}
                    // onCancelPressed={() => {
                    //   setShow(false);
                    // }}
                    onConfirmPressed={() => {
                        setWallet(false);
                        setTimeout(() => {
                            props.navigation.navigate("ordercolor")
                       }, 1000);
                        //props.navigation.navigate("home")
                    }}
                    titleStyle={{ fontFamily: "MontserratBold", fontSize: 13  ,color:Colors.success}}
                    messageStyle={{ fontFamily: "Montserrat", fontSize: 13 }}
                    confirmButtonTextStyle={{ fontFamily: "Montserrat", fontSize: 13 }}
                /> */}


            </View>
        </NativeBaseProvider>

    );
}

const styles = StyleSheet.create({

    viewContainer: {
        width: "100%",
        height: "100%",
        backgroundColor: Colors.background2,

    },
    viewHeader: {
        flexDirection: "row",
        width: "100%",
        height: Platform.OS == "web" ? 60 : 80,
        backgroundColor: Colors.primary,
    },
    viewmodal: {
        flexDirection: 'row',
        width: "100%",
        height: 60,
        marginTop: "10%",
        backgroundColor: Colors.background2
    },
    menu: {
        backgroundColor: Colors.primary,
        width: 40,
        height: 40,
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        right: 15,
        top: Platform.OS == "web" ? "20%" : "35%",

    },
    textheader: {
        backgroundColor: Colors.primary,
        width: 140,
        height: Platform.OS == "web" ? 40 : 60,
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        right: "12%",
        top: "22%"
    },

})




export default Mdfwhite